const LilDujourAlbumsStatic = () => {
    return (
      <>
        <div class="gallery_containerThree-static"> 

        <div class="gallery_item">
            <p class="gallery-tag">Mixtape</p>
            <a href="https://soundcloud.com/dujourmusic/hellscape-presentslil-dujour" target="_blank" rel="noopener noreferrer">
              <img src="https://i1.sndcdn.com/artworks-1rSSZehbsTvFfCFp-eqi6Hw-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>HELLSCAPE PRESENTS... LIL DUJOUR</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">EP</p>
            <a href="https://open.spotify.com/album/2gdhxenJ952mOx1cLE9fkr?si=U8L4XcFpTKyYx0lPN6HlHQ" target="_blank" rel="noopener noreferrer">
              <img src="https://i1.sndcdn.com/artworks-xSP18AVFYaNF6ukw-HQPBuA-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>LETS GET SICK</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">EP</p>
            <a href="https://open.spotify.com/album/7Ew0JxaudP3gXHpotxKC1I?si=S3WNSf1wSXaoXwjLe8Wsgg" target="_blank" rel="noopener noreferrer">
              <img src="https://i.scdn.co/image/ab67616d00001e026da154c391c3402feb412868" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>The Last Good Thing On This Sorry Side Of Town</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">EP</p>
            <a href="https://open.spotify.com/album/34l7sM6xBwBTvEiX72z164?si=rgilXLD7S7ubeJeap-ceww" target="_blank" rel="noopener noreferrer">
              <img src="https://i.scdn.co/image/ab67616d00001e02a6c5eff8b7d02aae0a1a6862" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Sincerely Yours</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">EP</p>
            <a href="https://open.spotify.com/album/75AVLIbB8IQazsz4if16l6?si=b0h6m5aGRfK8VWMcUx277g" target="_blank" rel="noopener noreferrer">
              <img src="https://i.scdn.co/image/ab67616d00001e023398d82e16c5c2128c862e3f" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Tell All Your Friends</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">EP</p>
            <a href="https://open.spotify.com/album/7xR4ZI8UGeg5z8j1VlGcpi?si=bxvwy3s6SOiVGtM7UZ7CNw" target="_blank" rel="noopener noreferrer">
              <img src="https://i.scdn.co/image/ab67616d00001e022237649dac155888cfd8412a" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Almost</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Album</p>
            <a href="https://open.spotify.com/album/4htHAea5YZtZetQWr3qwpq?si=WN1MoCEkRTeSweuqyIbfvQ" target="_blank" rel="noopener noreferrer">
              <img src="https://i.scdn.co/image/ab67616d00001e025dc08056c50d18f38df5cbe2" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>I Love You I Hate It Here</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Album</p>
            <a href="https://open.spotify.com/album/2MiNw4bMxOnmZJ6YDvILPp?si=CdhqC59fQ3uyD9tYIj-3jQ" target="_blank" rel="noopener noreferrer">
              <img src="https://i.scdn.co/image/ab67616d00001e0277b082ae8241471c036cc793" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>You Jump I Jump</strong><br/>
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">EP</p>
            <a href="https://open.spotify.com/track/4LorRg9eTGXtOps9R10Av6?si=1001f8c6e5344dbc" target="_blank" rel="noopener noreferrer">
              <img src="https://i1.sndcdn.com/artworks-SRXfoa59wlkrXuLc-dAt4gA-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kawaii Ry & Lil Dujour - Off Rip</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Album</p>
            <a href="https://open.spotify.com/album/6JyuUdKqlsHP78aKz7k8Yi?si=eUvrwOHCQfmQ5QeejMSwig" target="_blank" rel="noopener noreferrer">
              <img src="https://i.scdn.co/image/ab67616d00001e02aa772b7e194174be75e5aa4a" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Dude Where's My Plug?</strong><br/>
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">EP</p>
            <a href="https://open.spotify.com/album/26m1lwOE6ZsmCs1RFTzzcU?si=2Y1R-F4YRyihlpLV0NRhbQ" target="_blank" rel="noopener noreferrer">
              <img src="https://i.scdn.co/image/ab67616d00001e02932816f6096e5bbaa3eb34d9" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Love Star</strong><br/>
              </p>
            </a>
          </div>                                                                                                                               
        
        </div>
      </>
    );
  };
  export default LilDujourAlbumsStatic;